import { createSelector } from '@ngrx/store';

import { getSettingsState } from './main.selectors';

export const getIsUserNotifiedAboutPaymentRequired = createSelector(getSettingsState, (state) => state.isUserNotifiedAboutPaymentRequired);

export const getDataLayersOpenedPanel = createSelector(getSettingsState, (state) => state.dataLayersOpenedCategory);
